import React from 'react'
import styled from '@emotion/styled'
import { Label } from 'shared/ui'
import SpacedItems from 'shared/components/ui/SpacedItems'

const HotkeysGroupContainer = styled('div')`
  & + & {
    margin-top: ${props => props.theme.spacing['14']};
  }
`

const Title = styled(Label)`
  margin-bottom: ${props => props.theme.spacing['10']};
`

const Hotkey = styled(SpacedItems.Item)`
  display: flex;
`

const Key = styled('div')`
  margin-right: ${props => props.theme.spacing['10']};
  font-family: monospace;
`

export default function HotkeysGroup({ title, hotkeys }) {
  return (
    <HotkeysGroupContainer>
      <Title as="div">{title}</Title>

      <SpacedItems.Container direction="vertical" gap="mini">
        {Object.entries(hotkeys).map(([key, desctiption]) => (
          <Hotkey>
            <Key>{key}</Key>
            <div>{desctiption}</div>
          </Hotkey>
        ))}
      </SpacedItems.Container>
    </HotkeysGroupContainer>
  )
}
